import React, { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { dialogHide } from '../../modules/editor';
import {useHotkeys} from 'react-hotkeys-hook';
import { RootState } from '../../modules';

type Props = {
	show:boolean;
	msg:string;
	msgsub?:string;
	callback:any;
	labelConfirm?:string;
	labelCancel?:string;
};

function Dialog({ show, msg, msgsub, callback, labelCancel, labelConfirm }: Props) {
	const dispatch = useDispatch();
	const isLoadingPreview = useSelector((state: RootState) => state.editor.ui.isLoadingPreview);
	
	useHotkeys('Esc', () => {
		if (!show) return;
		dispatch(dialogHide());		
	});

	const cancel = (e:any) => {
		dispatch(dialogHide());
	}
	
	const runCallback = (e:any) => {
		callback();
		dispatch(dialogHide());
	}
	const isComponentSubMsg = useMemo(() => React.isValidElement(msgsub), [msgsub]);

	return (
		<>
		{ show && (
			<div className={isLoadingPreview ? "modal dialog modal-under-dim" : "modal dialog"}>
				<div className="modal-body">
					<h1 dangerouslySetInnerHTML={{ __html: msg }}></h1>
					{
						isComponentSubMsg
						? <div className='msg-sub'>{msgsub}</div>
						: <div className='msg-sub' dangerouslySetInnerHTML={{ __html: msgsub }}></div>
					}
					<div className="modal-footer">
						<button className="modal-btn btn short medium tertiary" onClick={cancel}>{labelCancel}</button>
						<button className="modal-btn btn short medium secondary" onClick={runCallback}>{labelConfirm}</button>
					</div>
				</div>
			</div>
		)}
		</>
	);
}

Dialog.defaultProps = {
	labelConfirm: '예',
	labelCancel: '아니요'
};

export default Dialog;